import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './partials/footer';
import Menu from './partials/menu';
import Navbar from './partials/navbar';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LayoutProvider, useLayout } from './LayoutContext';
import './responsive-layout.css';
import './layout-theme.scss';
import { auditService } from '../../common/services';

// Mapping des chemins vers des noms lisibles
const PAGE_TITLES = {
  '/dashboard': 'Tableau de bord',
  '/dashboard/categories': 'Categories',
  '/dashboard/ajouter-categorie': 'Ajout Categorie',
  '/dashboard/partenaires': 'Partenaires (TIGOON)',
  '/dashboard/chauffeurs': 'Chauffeurs (YANDEX)',
  '/dashboard/vehicules': 'Vehicules',
  '/dashboard/historique-numeros': 'Historique Numeros',
  '/dashboard/historique-vehicules-modifies': 'Historique Vehicules Modifies',
  '/dashboard/historique-transferts': 'Historique Transferts UV',
  '/dashboard/historique-sos-credit': 'Historique SOS Credits',
  '/dashboard/demandes-assistances': 'Demandes Assistances',
  '/dashboard/gestion-admins': 'Liste Administrateurs',
  '/dashboard/ajouter-admin': 'Ajout Administrateur',
  '/dashboard/roles': 'Gestion Roles',
  '/dashboard/ajouter-role': 'Ajout Role',
  '/dashboard/audit-log': 'Historique Activite',
  '/dashboard/wallet': 'Wallet',
  '/dashboard/historique-points': 'Historique Points',
  '/dashboard/historique-promotions': 'Promo Dimanche',
  '/dashboard/toutes-operations': 'Operations',
  '/dashboard/sites': 'Sites Terrain',
  '/dashboard/ajout-site': 'Ajout Site',
  '/dashboard/souscripteurs': 'Souscripteurs',
  '/dashboard/settings': 'Parametres',
  '/dashboard/sync-chauffeurs': 'Sync Chauffeurs',
  '/dashboard/sync-vehicules': 'Sync Vehicules',
  '/dashboard/sync-anciens-chauffeurs': 'Sync Anciens Chauffeurs',
  '/dashboard/sync-cache-yandex': 'Sync Cache Yandex',
  '/dashboard/banners': 'Bannieres Website',
  '/dashboard/vehicle-brands': 'Marques & Modeles',
  '/dashboard/vehicle-service-classes': 'Classes de service',
  '/dashboard/affiliates': 'Affilies',
  '/dashboard/affiliate-applications': 'Candidatures Affilies',
  '/dashboard/affiliate-commissions': 'Commissions Affilies',
  '/dashboard/commissions-130h': 'Commissions 130h',
  '/dashboard/ambassadors': 'Ambassadeurs',
  '/dashboard/ambassador-applications': 'Candidatures Ambassadeurs',
  '/dashboard/revenues': 'Revenus',
  '/dashboard/revenues-bonus-recharge': 'Bonus Recharge Jour',
  '/dashboard/revenues-130h': 'Revenus 130h',
  '/dashboard/revenues-payment-status': 'Etat Paiements',
  '/dashboard/rankings': 'Classement Chauffeurs',
  '/dashboard/cities': 'Villes',
  '/dashboard/profile': 'Profil',
};

const getPageTitle = (pathname) => {
  // Correspondance exacte d'abord
  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname];
  // Correspondance partielle pour les routes dynamiques (/partenaire/:id, etc.)
  const base = pathname.replace(/\/[a-f0-9]{24}/g, '').replace(/\/\d+/g, '');
  if (PAGE_TITLES[base]) return PAGE_TITLES[base];
  // Dernier segment du chemin
  const segments = pathname.split('/').filter(Boolean);
  return segments[segments.length - 1] || 'Page';
};

// Tracker les visites de page (fire-and-forget)
const PageTracker = () => {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    if (location.pathname !== lastPath.current) {
      lastPath.current = location.pathname;
      const title = getPageTitle(location.pathname);
      auditService.trackPageVisit({
        page: location.pathname,
        title: title,
      }).catch(() => {});
    }
  }, [location.pathname]);

  return null;
};

const LayoutShell = () => {
  const { sidebarOpen, isXLUp, closeSidebar } = useLayout();

  return (
    <>
      <PageTracker />
      <ToastContainer />
      <div className={`layout-wrapper layout-content-navbar ${sidebarOpen ? 'has-sidebar-open' : ''}`}>
        <div className="layout-container">
          {/* Menu */}
          <Menu />
          {/* / Menu */}

          {/* Layout container */}
          <div className="layout-page">
            {/* Navbar */}
            <Navbar />
            {/* / Navbar */}

            {/* Content wrapper */}
            <div className="content-wrapper">
              {/* Content */}
              <div className="page-content">
                <Outlet />
              </div>
              {/* / Content */}

              {/* Footer - à la fin du contenu */}
              <Footer />
            </div>
            {/* / Content wrapper */}
          </div>
          {/* / Layout page */}
        </div>

        {/* Overlay (mobile uniquement) */}
        {!isXLUp && sidebarOpen && (
          <div className="layout-overlay layout-menu-toggle show" onClick={closeSidebar} />
        )}
      </div>
    </>
  );
};

const MainLayout = () => (
  <LayoutProvider>
    <LayoutShell />
  </LayoutProvider>
);

export default MainLayout;
